import Http from '@/services/http';
import {
  sampleFieldsDefinitions,
} from '@/domain/data/installation/engineering/chromatography/sample';
import translate, { formatNumber } from '@/services/translate';
import { ChromatographySample } from 'sigma-mappings';
import {
  formatter as dateTimeFormatter,
  getNow,
  isValid as dateTimeIsValid,
} from '@/services/dateTime/datetimeService';
import { formats } from '@/constants/localizer';
import msis127Error from '@/domain/data/installation/engineering/cromaMSIS127ErrorHandler';

const urls = {
  base: assetModuleId => `/engenharia/${assetModuleId}/cromatografia/amostras`,
  byId: (assetModuleId, sampleId) => `${urls.base(assetModuleId)}/${sampleId}`,
  getSampleList: assetModuleId => `${urls.base(assetModuleId)}/listagem`,
  evolution: assetModuleId => `${urls.base(assetModuleId)}/evolucao`,
  reprocess: assetModuleId => `${urls.base(assetModuleId)}/reprocessar`,
};

const numberOptions = {
  maximumFractionDigits: 1,
  minimumFractionDigits: 1,
};

function getFaixaInicial(returnedField) {
  if (dateTimeIsValid(returnedField)) {
    dateTimeFormatter(returnedField.minValue, formats.DATETIME_SHORT);
  }
  return formatNumber(returnedField.minValue, numberOptions);
}

function getFaixaFinal(returnedField) {
  if (dateTimeIsValid(returnedField)) {
    return dateTimeFormatter(getNow(), formats.DATETIME_SHORT);
  }
  return formatNumber(returnedField.maxValue, numberOptions);
}

const { errorHandling, msis127ErrorHandler } = msis127Error;
/* istanbul ignore next */
const error = {
  errorHandling: {
    responseMessageParams: {
      $MA029: ({ field }) => {
        const returnedField = sampleFieldsDefinitions[field];
        if (!returnedField) return null;

        return {
          FaixaInicial: getFaixaInicial(returnedField),
          FaixaFinal: getFaixaFinal(returnedField),
          NomeDoCampo: translate(returnedField.name, { ...returnedField.textParams }),
        };
      },
      $MA038: ({ field }) => {
        const returnedField = sampleFieldsDefinitions[field];
        if (!returnedField) return null;

        return {
          FaixaInicial: getFaixaInicial(returnedField),
          NomeDoCampo: translate(returnedField.name),
        };
      },
      $MA058: ({ field }) => {
        const returnedField = sampleFieldsDefinitions[field];
        if (!returnedField) return null;
        return {
          NroCaracteres: returnedField.maxLength,
          NomeDoCampo: translate(returnedField.name),
        };
      },
      $MA005: ({ field }) => {
        const returnedField = sampleFieldsDefinitions[field];
        if (!returnedField) return null;

        return {
          NomeDoCampo: translate(returnedField.name),
        };
      },
    },
    ...errorHandling,
  },
};

export default {
  getList(assetModuleId) {
    const http = new Http(error);
    return http
      .post(urls.getSampleList(assetModuleId))
      .then(({ data }) => data);
  },
  get(assetModuleId, sampleId) {
    const http = new Http(error);
    return http
      .get(urls.byId(assetModuleId, sampleId))
      .then(({ data }) => new ChromatographySample(data))
      .catch(msis127ErrorHandler);
  },
  insert(assetModuleId, sample) {
    const http = new Http(error);
    return http.post(
      urls.base(assetModuleId),
      new ChromatographySample.MapBack(sample),
    );
  },
  update(assetModuleId, sampleId, sample) {
    const http = new Http(error);
    return http.put(
      urls.byId(assetModuleId, sampleId),
      new ChromatographySample.MapBack(sample),
    ).catch(msis127ErrorHandler);
  },
  delete(assetModuleId, sampleId) {
    const http = new Http(error);
    return http.delete(
      urls.byId(assetModuleId, sampleId),
    ).catch(msis127ErrorHandler);
  },
};
